export default __webpack_public_path__ + "static/OpenSans-Bold-b87be75f5095e2b4ffe9b3b69aac5438.woff2";